const typography = {
    fontFamily: [
        'proxima-nova',
        'itc-avant-garde-gothic-pro',
        '-apple-system',
        'BlinkMacSystemFont',
        '"Segoe UI"',
        'Roboto',
        '"Helvetica Neue"',
        'Arial',
        'sans-serif',
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
    ].join(','),
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': ['proxima-nova'],
            },
        },
    },
    fontSize: 12,
    h1: {
        fontWeight: 500,
        fontSize: '1.25rem',
        lineHeight: 1.4,
    },
    h2: {
        fontWeight: 500,
        fontSize: '1rem',
        lineHeight: 1.4,
    },
    h3: {
        fontWeight: 500,
        fontSize: '1rem',
        lineHeight: 1.4,
    },
    h4: {
        fontWeight: 500,
        fontSize: '1rem',
        lineHeight: 1.4,
    },
    h5: {
        fontWeight: 500,
        fontSize: '1rem',
        lineHeight: 1.4,
    },
    h6: {
        fontWeight: 400,
        fontSize: '0.8rem',
        lineHeight: 1.4,
        color: '#99a5bd',
    },
};
export default typography;
